export default __webpack_public_path__ + "static/media/Servízen.bc2ca1b3.svg";